/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Howcancustomersreachyou4Inputs */

const en_howcancustomersreachyou4 = /** @type {(inputs: Howcancustomersreachyou4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can customers reach you?`)
};

const de_howcancustomersreachyou4 = /** @type {(inputs: Howcancustomersreachyou4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie erreichen dich Gäste?`)
};

/**
* | output |
* | --- |
* | "How can customers reach you?" |
*
* @param {Howcancustomersreachyou4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const howcancustomersreachyou4 = /** @type {((inputs?: Howcancustomersreachyou4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Howcancustomersreachyou4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_howcancustomersreachyou4(inputs)
	return de_howcancustomersreachyou4(inputs)
});
export { howcancustomersreachyou4 as "howCanCustomersReachYou" }